<template>
    <div class="filter-container">
        <!-- 写字楼买卖单价 -->
        <el-row class="filter-row" v-if="typeTxt == '写字楼买卖'">
            <el-col :span="1" class="label">单价：</el-col>
            <el-col :span="18" class="filter-options">
                <span 
                    v-for="(item, index) in mmpriceList" 
                    :key="index"
                    class="option-item"
                    :class="{ active: mmprice == index }"
                    @click="changeType('mmprice', item, index)"
                >
                    {{ item.name }}
                </span>
            </el-col>
            <el-col :span="5">
                <div class="price-input">
                    <input type="number" min="0" v-model="mmpricel" class="input-box" />
                    <span class="separator">-</span>
                    <input type="number" min="0" class="input-box" v-model="mmpriceh" />
                    <el-button type="danger" size="small" @click="inputBtn(mmpricel, mmpriceh, 'mmprice')">确定</el-button>
                </div>
            </el-col>
        </el-row>

        <!-- 写字楼租赁单价 -->
        <el-row class="filter-row" v-if="typeTxt == '写字楼租赁'">
            <el-col :span="1" class="label">单价：</el-col>
            <el-col :span="18" class="filter-options">
                <span 
                    v-for="(item, index) in zlpriceList" 
                    :key="index"
                    class="option-item"
                    :class="{ active: zlprice == index }"
                    @click="changeType('zlprice', item, index)"
                >
                    {{ item.name }}
                </span>
            </el-col>
            <el-col :span="5">
                <div class="price-input">
                    <input type="number" min="0" v-model="zlpricel" class="input-box" />
                    <span class="separator">-</span>
                    <input type="number" min="0" class="input-box" v-model="zlpriceh" />
                    <el-button type="danger" size="small" @click="inputBtn(zlpricel, zlpriceh, 'zlprice')">确定</el-button>
                </div>
            </el-col>
        </el-row>

        <!-- 面积筛选 -->
        <el-row class="filter-row">
            <el-col :span="1" class="label">面积：</el-col>
            <el-col :span="18" class="filter-options">
                <span 
                    v-for="(item, index) in areaList" 
                    :key="index"
                    class="option-item"
                    :class="{ active: area == index }"
                    @click="changeType('area', item, index)"
                >
                    {{ item.name }}
                </span>
            </el-col>
            <el-col :span="5">
                <div class="price-input">
                    <input type="number" min="0" v-model="areal" class="input-box" />
                    <span class="separator">-</span>
                    <input type="number" min="0" class="input-box" v-model="areah" />
                    <el-button type="danger" size="small" @click="inputBtn(areal, areah, 'area')">确定</el-button>
                </div>
            </el-col>
        </el-row>

        <!-- 装修筛选 -->
        <el-row class="filter-row">
            <el-col :span="1" class="label">装修：</el-col>
            <el-col :span="18" class="filter-options">
                <span 
                    v-for="(item, index) in decorationList" 
                    :key="index"
                    class="option-item"
                    :class="{ active: decoration == index }"
                    @click="changeType('decoration', item, index)"
                >
                    {{ item.name }}
                </span>
            </el-col>
        </el-row>

        <!-- 已选条件 -->
       <!--  <div v-if="selectArr.length > 0" class="selected-filters">
            <el-row>
                <el-col :span="1" class="label">已选：</el-col>
                <el-col :span="23">
                    <div class="selected-tags">
                        <div 
                            v-for="(item, index) in selectArr" 
                            :key="index"
                            v-if="item.name != '不限'"
                            class="tag-item"
                        >
                            <span>{{ item.name }}</span>
                            <i class="el-icon-close" @click="close(item, index)"></i>
                        </div>
                        <el-button 
                            type="text" 
                            class="clear-btn"
                            @click="clearAll" 
                            icon="el-icon-delete"
                        >
                            清空
                        </el-button>
                    </div>
                </el-col>
            </el-row>
        </div> -->
    </div>
</template>

<script>
export default {
    data() {
        return {
            typeList: [
                { val: "", name: "不限" },
                { val: "普通办公", name: "普通办公" },
                { val: "联合办公", name: "联合办公" },
                { val: "大业主", name: "大业主" },
            ],
            type: "0",
            mmpriceList: [
                { val: "-", name: "不限" },
                { val: "0-10000", name: "<1万元/m²" },
                { val: "10000-20000", name: "1-2万元/m²" },
                { val: "20000-30000", name: "2-3万元/m²" },
                { val: "30000-50000", name: "3-5万元/m²" },
                { val: "50000-", name: ">5万元/m²" },
            ],
            mmprice: "0",
            mmtotalList: [
                { val: "-", name: "不限" },
                { val: "0-100", name: "<100万" },
                { val: "100-200", name: "100-200万" },
                { val: "200-300", name: "200-300万" },
                { val: "300-500", name: "300-500万" },
                { val: "500-800", name: "500-800万" },
                { val: "800-100000", name: ">800万" },
            ],
            mmtotal: "0",
            zlpriceList: [
                { val: "-", name: "不限" },
                { val: "0-40", name: "<40元/m²/月" },
                { val: "40-70", name: "40-70元/m²/月" },
                { val: "70-100", name: "70-100元/m²/月" },
                { val: "100-140", name: "100-140元/m²/月" },
                { val: "140-100000", name: ">140元/m²/月" },
            ],
            zlprice: "0",
            zltotalList: [
                { val: "-", name: "不限" },
                { val: "0-5000", name: "0-5万元/月" },
                { val: "5000-10000", name: "0.5-1万元/月" },
                { val: "10000-15000", name: "1-1.5万元/月" },
                { val: "15000-25000", name: "1.5-2.5万元/月" },
                { val: "25000-40000", name: "2.5-4万元/月" },
                { val: "40000-1000000", name: ">4万元/月" },
            ],
            zltotal: 0,
            areaList: [
                { val: "-", name: "不限" },
                { val: "0-100", name: "<100m²" },
                { val: "100-300", name: "100-300m²" },
                { val: "300-500", name: "300-500m²" },
                { val: "500-1000", name: "500-1000m²" },
                { val: "1000-100000", name: ">1000m²" },
            ],
            area: "0",
            decorationList: [
            ],
            decoration: "0",
            mmpricel: "",
            mmpriceh: "",
            mmtotall: "",
            mmtotalh: "",
            zlpricel: "",
            zlpriceh: "",
            zltotall: "",
            zltotalh: "",
            areal: "",
            areah: "",
            selectArr: [],
            selectedValues: {
                mmprice: "-",
                zlprice: "-",
                mmtotal: "-",
                zltotal: "-",
                area: "-",
                decoration: null
            }
        };
    },
    props: ["typeTxt", "params"],
    created() {
        this.getDictRenovation();
    },
    mounted() { },
    watch: {
        typeTxt() {
            this.clearAll();
        },
        params(val) {
            if (val) {
                let params = JSON.parse(val);
                
                // 处理装修参数
                if (params.renovation) {
                    this.decorationList.forEach((it, index) => {
                        if (it.val === params.renovation) {
                            this.decoration = index;
                            this.changeType('decoration', it, index);
                        }
                    });
                } else if (params.zx) {
                    this.decorationList.forEach((it, index) => {
                        if (it.val === params.zx) {
                            this.decoration = index;
                            this.changeType('decoration', it, index);
                        }
                    });
                }
                
                // 处理面积参数
                if (params.areas && params.areae) {
                    const areaRange = params.areas + "-" + params.areae;
                    this.areaList.forEach((it, index) => {
                        if (it.val === areaRange) {
                            this.area = index;
                            this.changeType('area', it, index);
                        }
                    });
                    
                    // 如果不匹配预定义范围，则使用自定义输入
                    if (this.area === "0" && params.areas !== "0") {
                        this.areal = params.areas;
                        this.areah = params.areae;
                        this.inputBtn(params.areas, params.areae, 'area');
                    }
                } else if (params.area) {
                    // 处理从首页传过来的area参数
                    this.areaList.forEach((it, index) => {
                        if (it.val === params.area) {
                            this.area = index;
                            this.changeType('area', it, index);
                        }
                    });
                }
            }
        },
    },
    methods: {
        getDictRenovation() {
            let dictRenovation = this.commonfun.getDictList('dictRenovation');
            let decorationList = [{ val: null, name: "不限" }]; // 添加"不限"选项
            decorationList = decorationList.concat(
                dictRenovation.map(item => {
                    return {
                        val: item.dictValue, // 将 dictLabel 作为 val
                        name: item.dictLabel // 将 dictLabel 作为 name
                    };
                })
            );
            this.decorationList = decorationList;
            console.log(decorationList);
        },
        changeType(type, it, index) {
            // 清空对应类型的输入框
            if (type === "mmprice") {
                this.mmpricel = "";
                this.mmpriceh = "";
            } else if (type === "zlprice") {
                this.zlpricel = "";
                this.zlpriceh = "";
            } else if (type === "mmtotal") {
                this.mmtotall = "";
                this.mmtotalh = "";
            } else if (type === "zltotal") {
                this.zltotall = "";
                this.zltotalh = "";
            } else if (type === "area") {
                this.areal = "";
                this.areah = "";
            }

            // 原有的逻辑
            this[type] = index;
            let obj = { label: type, val: it.val };
            let showobj = { label: type, val: it.val, name: it.name, index };
            let labelSet = new Set(this.selectArr.map(item => item.label));
            if (!labelSet.has(type)) {
                this.selectArr.push(showobj);
            } else {
                this.selectArr = this.selectArr.map(item => (item.label === type ? showobj : item));
            }
            this.$emit("changeVal", obj);
        },
        close(item, i) {
            console.log(item.index);
            this[item.label] = 0;
            this.selectArr.splice(i, 1);
            let obj = { label: item.label, val: "-" };
            this.$emit("changeVal", obj);
        },
        clearAll() {
            if (this.selectArr.length > 0) {
                this.selectArr.forEach((item, index) => {
                    let obj = { label: item.label, val: "-" };
                    this[item.label] = 0;
                    this.$emit("changeVal", obj);
                });
                this.selectArr = [];
            }
        },
        inputBtn(vall, valh, type) {
            // 清除之前的选中状态
            if (vall !== "" && valh !== "") {
                let obj = "";
                if (vall < valh) {
                    obj = { label: type, val: vall + "-" + valh };
                } else {
                    obj = { label: type, val: valh + "-" + vall };
                }

                // 清除对应类型的单选项选中状态
                if (type === "mmprice") {
                    this.mmprice = "-1"; // 重置为默认值（不限）
                } else if (type === "zlprice") {
                    this.zlprice = "-1"; // 重置为默认值（不限）
                } else if (type === "mmtotal") {
                    this.mmtotal = "-1"; // 重置为默认值（不限）
                } else if (type === "zltotal") {
                    this.zltotal = "-1"; // 重置为默认值（不限）
                } else if (type === "area") {
                    this.area = "-1"; // 重置为默认值（不限）
                }

                // 更新已选条件数组
                let showobj = {
                    label: type,
                    val: obj.val,
                    name: `${vall}-${valh}`,
                    index: 0
                };
                
                let labelSet = new Set(this.selectArr.map(item => item.label));
                if (!labelSet.has(type)) {
                    this.selectArr.push(showobj);
                } else {
                    this.selectArr = this.selectArr.map(item => 
                        item.label === type ? showobj : item
                    );
                }

                // 发送请求到父组件
                this.$emit("changeVal", obj);
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.filter-container {
   // width: 75rem;
    margin: 0 auto;
   background: #f7f7f7;
    border-radius: 0 0 4px 4px;
    box-shadow: 0 2px 12px 0 rgba(0,0,0,0.05);
    padding: 15px 20px;
    border-top: 1px solid #EBEEF5;
}

.filter-row {
    display: flex;
    align-items: center;
    margin-bottom: 15px;
    
    &:last-child {
        margin-bottom: 0;
    }
}

.label {
    color: #333;
    font-size: 14px;
    font-weight: 600;
    line-height: 32px;
}

.filter-options {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    
    .el-checkbox {
        margin-right: 0;
    }
}

.option-item {
    display: inline-block;
    padding: 4px 12px;
    font-size: 14px;
    color: #666;
    cursor: pointer;
    border-radius: 4px;
    transition: all 0.3s ease;
    width: 12%;
    text-align: center;

    &:first-child {
        width: 5%;
    }

    &:hover {
        color: #DA251D;
    }

    &.active {
        color: #DA251D;
        font-weight: 600;
        background: rgba(218, 37, 29, 0.05);
    }
}

.price-input {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 8px;

    .input-box {
        width: 80px;
        height: 32px;
        padding: 0 8px;
        border: 1px solid #DCDFE6;
        border-radius: 4px;
        font-size: 14px;
        
        &:focus {
            border-color: #DA251D;
            outline: none;
        }
    }

    .separator {
        color: #909399;
    }

    .el-button {
        margin-left: 8px;
        
        &.el-button--danger {
            background-color: #DA251D;
            border-color: #DA251D;
            
            &:hover, &:focus {
                background-color: #f56c6c;
                border-color: #f56c6c;
            }
        }
    }
}

.selected-filters {
    margin-top: 15px;
    padding-top: 15px;
    border-top: 1px solid #EBEEF5;
}

.selected-tags {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    align-items: center;
}

.tag-item {
    display: inline-flex;
    align-items: center;
    padding: 5px 10px;
    background: #F5F7FA;
    border: 1px dashed #DCDFE6;
    border-radius: 4px;
    font-size: 12px;
    color: #606266;
    transition: all 0.3s ease;

    &:hover {
        border-color: #DA251D;
        color: #DA251D;
    }

    .el-icon-close {
        margin-left: 5px;
        cursor: pointer;
        
        &:hover {
            color: #DA251D;
        }
    }
}

.clear-btn {
    color: #909399;
    
    &:hover {
        color: #DA251D;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/officeFilter.vue